export enum EActiveStatus {
  Inactive = 2,
  Active = 3,
}
